var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnershipImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 324.06 323.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:url(#linear-gradient);}.cls-5{opacity:0.3;}.cls-6{clip-path:url(#clip-path-4);}.cls-7{fill:#91b3fa;}.cls-8{clip-path:url(#clip-path-5);}.cls-9{fill:#bdd0fb;}.cls-10{clip-path:url(#clip-path-6);}.cls-11{clip-path:url(#clip-path-7);}.cls-12{clip-path:url(#clip-path-8);}.cls-13{fill:url(#linear-gradient-2);}.cls-14{opacity:0.31;}.cls-15{clip-path:url(#clip-path-10);}.cls-16{opacity:0.68;}.cls-17{clip-path:url(#clip-path-11);}.cls-18{clip-path:url(#clip-path-12);}.cls-19{fill:#fff;}.cls-20{clip-path:url(#clip-path-13);}.cls-21{clip-path:url(#clip-path-14);}.cls-22{clip-path:url(#clip-path-15);}.cls-23{clip-path:url(#clip-path-16);}.cls-24{clip-path:url(#clip-path-17);}.cls-25{clip-path:url(#clip-path-18);}.cls-26{clip-path:url(#clip-path-19);}.cls-27{fill:url(#linear-gradient-3);}.cls-28{clip-path:url(#clip-path-20);}.cls-29{fill:url(#linear-gradient-4);}.cls-30{clip-path:url(#clip-path-21);}.cls-31{fill:url(#linear-gradient-5);}.cls-32{clip-path:url(#clip-path-22);}.cls-33{fill:url(#linear-gradient-6);}.cls-34{clip-path:url(#clip-path-23);}.cls-35{fill:url(#linear-gradient-7);}.cls-36{clip-path:url(#clip-path-24);}.cls-37{fill:url(#linear-gradient-8);}.cls-38{clip-path:url(#clip-path-25);}.cls-39{fill:url(#linear-gradient-9);}.cls-40{clip-path:url(#clip-path-26);}.cls-41{fill:url(#linear-gradient-10);}.cls-42{clip-path:url(#clip-path-27);}.cls-43{fill:url(#linear-gradient-11);}.cls-44{clip-path:url(#clip-path-28);}.cls-45{fill:url(#linear-gradient-12);}.cls-46{clip-path:url(#clip-path-29);}.cls-47{fill:url(#linear-gradient-13);}.cls-48{clip-path:url(#clip-path-30);}.cls-49{fill:url(#linear-gradient-14);}.cls-50{clip-path:url(#clip-path-31);}.cls-51{fill:url(#linear-gradient-15);}.cls-52{clip-path:url(#clip-path-32);}.cls-53{fill:url(#linear-gradient-16);}.cls-54{clip-path:url(#clip-path-33);}.cls-55{fill:url(#linear-gradient-17);}.cls-56{clip-path:url(#clip-path-34);}.cls-57{fill:url(#linear-gradient-18);}.cls-58{clip-path:url(#clip-path-36);}.cls-59{fill:url(#linear-gradient-19);}.cls-60{clip-path:url(#clip-path-37);}.cls-61{fill:url(#linear-gradient-20);}.cls-62{clip-path:url(#clip-path-38);}.cls-63{fill:url(#linear-gradient-21);}.cls-64{clip-path:url(#clip-path-39);}.cls-65{fill:url(#linear-gradient-22);}.cls-66{clip-path:url(#clip-path-40);}.cls-67{fill:url(#linear-gradient-23);}.cls-68{clip-path:url(#clip-path-41);}.cls-69{fill:url(#linear-gradient-24);}.cls-70{clip-path:url(#clip-path-42);}.cls-71{fill:url(#linear-gradient-25);}.cls-72{clip-path:url(#clip-path-44);}.cls-73{fill:url(#linear-gradient-26);}.cls-74{clip-path:url(#clip-path-45);}.cls-75{fill:url(#linear-gradient-27);}.cls-76{clip-path:url(#clip-path-46);}.cls-77{fill:url(#linear-gradient-28);}.cls-78{clip-path:url(#clip-path-47);}.cls-79{fill:url(#linear-gradient-29);}.cls-80{clip-path:url(#clip-path-48);}.cls-81{fill:url(#linear-gradient-30);}.cls-82{clip-path:url(#clip-path-49);}.cls-83{fill:url(#linear-gradient-31);}.cls-84{clip-path:url(#clip-path-50);}.cls-85{fill:url(#linear-gradient-32);}.cls-86{clip-path:url(#clip-path-51);}.cls-87{fill:url(#linear-gradient-33);}.cls-88{clip-path:url(#clip-path-52);}.cls-89{fill:url(#linear-gradient-34);}.cls-90{clip-path:url(#clip-path-53);}.cls-91{fill:url(#linear-gradient-35);}.cls-92{clip-path:url(#clip-path-54);}.cls-93{fill:url(#linear-gradient-36);}.cls-94{clip-path:url(#clip-path-55);}.cls-95{fill:url(#linear-gradient-37);}.cls-96{clip-path:url(#clip-path-56);}.cls-97{fill:url(#linear-gradient-38);}.cls-98{clip-path:url(#clip-path-57);}.cls-99{fill:url(#linear-gradient-39);}.cls-100{clip-path:url(#clip-path-58);}.cls-101{fill:url(#linear-gradient-40);}.cls-102{clip-path:url(#clip-path-59);}.cls-103{fill:url(#linear-gradient-41);}.cls-104{clip-path:url(#clip-path-60);}.cls-105{fill:url(#linear-gradient-42);}.cls-106{clip-path:url(#clip-path-61);}.cls-107{fill:url(#linear-gradient-43);}.cls-108{clip-path:url(#clip-path-62);}.cls-109{fill:url(#linear-gradient-44);}.cls-110{clip-path:url(#clip-path-63);}.cls-111{fill:url(#linear-gradient-45);}.cls-112{clip-path:url(#clip-path-64);}.cls-113{fill:url(#linear-gradient-46);}.cls-114{clip-path:url(#clip-path-65);}.cls-115{fill:url(#linear-gradient-47);}.cls-116{clip-path:url(#clip-path-66);}.cls-117{fill:url(#linear-gradient-48);}.cls-118{clip-path:url(#clip-path-67);}.cls-119{fill:url(#linear-gradient-49);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 155.37,
    height: 154.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.13,1.08C35.05,5.4,18.77,32.37,15.69,37.23-1.15,63.79-4.54,104,17.18,129.57c14.36,16.88,34.21,20.91,44.49,23,7,1.41,39.68,7.2,67.34-12.65a55.11,55.11,0,0,0,8.48-7.14c23.86-25.11,26.38-85.16-9.09-114.88C114.27,6.06,95.64.43,78.21.43a79.1,79.1,0,0,0-10.08.65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -19.39,
    y1: 170.05,
    x2: -19.39,
    y2: 170.05,
    gradientTransform: "matrix(520.87, 0, 0, -517.77, 10100.87, 88127.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.04,
    y: 26.06,
    width: 46.41,
    height: 31.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.62,
    width: 48.47,
    height: 33.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.1,
    y: 56.32,
    width: 32.36,
    height: 13.23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 30.89,
    width: 20.98,
    height: 22.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.81,91.58c-1.43,32.78,26.08,60.61,61.47,62.17S144.51,130,146,97.21,119.87,36.59,84.49,35c-1,0-2.07-.07-3.09-.07-34,0-62.19,24.79-63.59,56.61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -19.23,
    y1: 170,
    x2: -19.22,
    y2: 170,
    gradientTransform: "matrix(379.26, 0, 0, -366.86, 7291.16, 62462.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.09,
    y: 42.57,
    width: 100.64,
    height: 95.07
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.55,
    y: 36.53,
    width: 116.31,
    height: 116.36
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.44,
    y: 36.85,
    width: 32.82,
    height: 116.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.62,
    y: 36.53,
    width: 89.07,
    height: 116.36
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.2,
    y: 71.43,
    width: 107.02,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.7,
    y: 49.05,
    width: 76.01,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.55,
    y: 93.82,
    width: 116.31,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.2,
    y: 116.21,
    width: 107.02,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.47,
    y: 138.66,
    width: 76.32,
    height: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.25,59.86a9.62,9.62,0,0,0-.87,1.4,1.18,1.18,0,0,0,.19,1.38l.83.86a1.87,1.87,0,0,0,2.65,0,1.54,1.54,0,0,0,.17-.19,3.35,3.35,0,0,0,.69-1.88s-2.58-1.69-3.44-1.69a.29.29,0,0,0-.22.07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -8.24,
    y1: 154.79,
    x2: -8.24,
    y2: 154.79,
    gradientTransform: "matrix(12.53, 0, 0, -12.09, 103.24, 1932.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.19,57.48s-1.1-2.91-2.39-2.64a8.66,8.66,0,0,0-2.7,1.26L62,58.9s5.81,2.28,7.85,1a44.79,44.79,0,0,0,13.43-.2A29.76,29.76,0,0,1,81.2,53.3a31.2,31.2,0,0,1-12,4.18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -16.86,
    y1: 162.98,
    x2: -16.86,
    y2: 162.98,
    gradientTransform: "matrix(50.02, 0, 0, -24.5, 843.41, 4050.53)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.2,53.3a29.24,29.24,0,0,0,2.12,6.37,35.16,35.16,0,0,0,17.79-8.08l-.48-15.17S92.13,47.12,81.2,53.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -21.74,
    y1: 166.48,
    x2: -21.74,
    y2: 166.48,
    gradientTransform: "matrix(66.51, 0, 0, -62.89, 1445.67, 10517.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.63,36.42,99.77,42c-.77,5,.82,9.73,2.57,14.44,5.56,15,7.23,19.53,8.89,27.42,6.58,1.8,12.44.21,17.45-5.4,11.1-35.08-5.25-42.19-5.25-42.19a39.39,39.39,0,0,0-11-1.52,40.66,40.66,0,0,0-11.85,1.68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -20.7,
    y1: 168.88,
    x2: -20.7,
    y2: 168.88,
    gradientTransform: "matrix(142.94, 0, 0, -131.99, 2958.88, 22350.83)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.47,29.3l2.8,6.74a1.33,1.33,0,0,0,1,.8c1.61.28,5.52.71,8.09-1a.67.67,0,0,0,.19-.91h0l-5.18-7.44Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -19.3,
    y1: 162.84,
    x2: -19.3,
    y2: 162.84,
    gradientTransform: "matrix(33.45, 0, 0, -30.24, 645.76, 4956.87)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.37,19c-.12.11-5,9.64-5,9.64l5.5,2.66,5.94-8.35s-3.34-4.31-5.52-4.31a1.34,1.34,0,0,0-.95.36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -25.2,
    y1: 163.51,
    x2: -25.2,
    y2: 163.51,
    gradientTransform: "matrix(36.45, 0, 0, -35.03, 918.45, 5751.8)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.44,17.7c-.52,1.8,2.13,3.07,3.8,3.28,1.22.15,1.9,1.49,2.17,2.19a.91.91,0,0,1-.07.77l-2.74,4.57a.7.7,0,0,1-.15.19,1.44,1.44,0,0,1-2.31,0A7.84,7.84,0,0,0,102,26.34a.88.88,0,0,0-1.18.38h0a34.22,34.22,0,0,0-1.88,4.46.88.88,0,0,0,.51,1.07,24.12,24.12,0,0,0,5.27,1.53.87.87,0,0,0,.83-.35c.84-1.15,3.21-4.37,4-5.17s2.13-.47,2.76-.29a.86.86,0,0,0,.7-.09,1.93,1.93,0,0,0,.72-2.94.89.89,0,0,1,.28-1.2,1.94,1.94,0,0,0,.74-2.75,2.74,2.74,0,0,0-3-1.45.91.91,0,0,1-1-.53.59.59,0,0,0-.45-.36.85.85,0,0,1-.69-1v0a2.25,2.25,0,0,0-1.25-2.57,3,3,0,0,0-1.49-.4c-1.71,0-3.08,1.61-3.49,3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -21.31,
    y1: 165.85,
    x2: -21.31,
    y2: 165.85,
    gradientTransform: "matrix(56.99, 0, 0, -57.23, 1214.57, 9515.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.38,29.64s1.19,2.19,3.27.3c1.67-1.51.61-2.85-.74-3h-.08c-1.32,0-2.45,2.66-2.45,2.66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -34.11,
    y1: 154.23,
    x2: -34.11,
    y2: 154.23,
    gradientTransform: "matrix(14.48, 0, 0, -14.59, 493.98, 2278.88)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.8,153.92a.53.53,0,0,0,.19.72.73.73,0,0,0,.24.07,126.46,126.46,0,0,0,14,0,.73.73,0,0,0,.7-.69c0-.07,0-.15,0-.23a10.13,10.13,0,0,1-4.1.4c-3.57-.16-8.11-.52-10.72-.75a3.45,3.45,0,0,0-.35.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -55.45,
    y1: 165.62,
    x2: -55.44,
    y2: 165.62,
    gradientTransform: "matrix(4.08, 0, 0, -34.69, 226.35, 5899.39)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.88,148.15s-8.15,2.12-10.72,5.27c2.61.23,7.14.59,10.72.75a10.55,10.55,0,0,0,4.1-.4,9.69,9.69,0,0,0-1.8-5.62Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -18.45,
    y1: 166.92,
    x2: -18.44,
    y2: 166.92,
    gradientTransform: "matrix(35.93, 0, 0, -22.42, 662.74, 3894.44)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.28,144.39l.74,4.15a1.15,1.15,0,0,0,.78.88,3.75,3.75,0,0,0,1.73.15,1,1,0,0,0,.83-.92l.21-4.26Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -15.05,
    y1: 167.07,
    x2: -15.04,
    y2: 167.07,
    gradientTransform: "matrix(9.68, 0, 0, -11.84, 228.03, 2206.71)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.47,154.14a7,7,0,0,1-3.94-.21h0a2.73,2.73,0,0,0,2.06.95,6.44,6.44,0,0,0,2.75-.43,1.47,1.47,0,0,0,1-1.68v0a2.08,2.08,0,0,1-1.86,1.38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -56.04,
    y1: 161.25,
    x2: -56.03,
    y2: 161.25,
    gradientTransform: "matrix(5, 0, 0, -13.51, 280.44, 2331.79)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150,144.36h-1.9a2.39,2.39,0,0,0-1.31,2.75,18,18,0,0,0,2.71,6.82,7,7,0,0,0,3.94.21,2.08,2.08,0,0,0,1.86-1.38c-.59-2.35-2.4-8.4-5.26-8.4h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -23.19,
    y1: 166.16,
    x2: -23.19,
    y2: 166.16,
    gradientTransform: "matrix(29.96, 0, 0, -29.23, 694.79, 5005.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.74,141.37l1.54,4.41a1,1,0,0,0,.78.64,4.05,4.05,0,0,0,2.18-.53,1.13,1.13,0,0,0,.59-1.29l-1.05-4.19Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -20.98,
    y1: 167.22,
    x2: -20.97,
    y2: 167.22,
    gradientTransform: "matrix(11.78, 0, 0, -13.76, 329.55, 2525.36)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.81,82.61c4.14,15.67,7.35,40.15,7.55,62.94,0,0,3.27,1.12,5.81,0,0,0,1.74-35.73-.48-49.65,0,0,6.41,10.15,21.77,47,0,0,4.27-.15,5.58-1.31,0,0-13.74-49-22.4-62.94-1.8,1.43-7.44,3.69-17.83,3.93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -19.18,
    y1: 169.62,
    x2: -18.74,
    y2: 169.62,
    gradientTransform: "matrix(163.28, 0, 0, -177.3, 3226.61, 30186.08)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.19,92.91l1.91,11.89a3.91,3.91,0,0,0,4.35,3.25l28.6-3.48a2.83,2.83,0,0,0,2.49-2.75,52.82,52.82,0,0,0-1.35-13.51Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -19.25,
    y1: 168.32,
    x2: -19.25,
    y2: 168.32,
    gradientTransform: "matrix(89.67, 0, 0, -56.14, 1726.11, 9548.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.91,81.76a.72.72,0,0,0-.48.49l0,.93,5-.5-.29-1a3.06,3.06,0,0,0-1.52-.32,10.8,10.8,0,0,0-2.7.44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -16.37,
    y1: 144.69,
    x2: -16.36,
    y2: 144.69,
    gradientTransform: "matrix(11.65, 0, 0, -5.42, 190.68, 866.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.65,78.65l.37,2.88a.56.56,0,0,0,.49.49,1.46,1.46,0,0,0,.62-.08.56.56,0,0,0,.35-.6l-.36-2.88Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -12.33,
    y1: 153.73,
    x2: -12.32,
    y2: 153.73,
    gradientTransform: "matrix(5.08, 0, 0, -8.49, 62.65, 1385.07)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.12,80a.7.7,0,0,0-.48.48l0,.93,5-.49-.29-1.05a3.18,3.18,0,0,0-1.52-.32,10.8,10.8,0,0,0-2.7.44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -19.13,
    y1: 144.64,
    x2: -19.12,
    y2: 144.64,
    gradientTransform: "matrix(11.65, 0, 0, -5.42, 222.85, 864.09)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.82,76.53l.41,3.18a.55.55,0,0,0,.49.49,1.46,1.46,0,0,0,.62-.08.56.56,0,0,0,.35-.6l-.41-3.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -18.67,
    y1: 154.94,
    x2: -18.66,
    y2: 154.94,
    gradientTransform: "matrix(5.25, 0, 0, -9.18, 97.96, 1500.12)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.78,72.79c-3,.31-10.44,1.27-14.36,3.43a1.48,1.48,0,0,0-.75,1.12,3.47,3.47,0,0,0,.17,1.6.67.67,0,0,0,.75.43l15.71-2.54a.76.76,0,0,0,.65-.72,6.74,6.74,0,0,0-.21-2A1.84,1.84,0,0,0,131,72.78h-.19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -18.91,
    y1: 162.88,
    x2: -18.91,
    y2: 162.88,
    gradientTransform: "matrix(40.53, 0, 0, -19.23, 766.36, 3208.54)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.68,75a16.91,16.91,0,0,0-3.86,1.25,1.41,1.41,0,0,0-.84,1.1,3.7,3.7,0,0,0,.06,1.24.17.17,0,0,0,.17.13h0a.17.17,0,0,0,.12-.21,3.77,3.77,0,0,1-.05-1.11,1.07,1.07,0,0,1,.64-.84,17.12,17.12,0,0,1,3.77-1.22.17.17,0,0,0,.15-.2.18.18,0,0,0-.17-.14h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -48.26,
    y1: 155.63,
    x2: -48.25,
    y2: 155.63,
    gradientTransform: "matrix(8.51, 0, 0, -11.35, 410.5, 1842.68)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.7,79.94c-6.5,0-28.52,3.1-33.6,3.81A1.36,1.36,0,0,0,106.93,85a51.58,51.58,0,0,0,.95,9.66,1.24,1.24,0,0,0,1.13,1l16,1.1,5.19-.66,14.27-4.64a1.14,1.14,0,0,0,.79-1.21A43.06,43.06,0,0,0,143,80.8a1.3,1.3,0,0,0-1.24-.86h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -19.32,
    y1: 167.85,
    x2: -19.32,
    y2: 167.85,
    gradientTransform: "matrix(92.24, 0, 0, -53.13, 1782.2, 9006.23)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.5,91.61l-5.47.7a1.18,1.18,0,0,0-1,1.32l0,.14,1.08,4.31a1.19,1.19,0,0,0,1.31.88l4.54-.58a1.19,1.19,0,0,0,1-1.22l-.17-4.42a1.18,1.18,0,0,0-1.23-1.14h-.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -26.28,
    y1: 162.64,
    x2: -26.28,
    y2: 162.64,
    gradientTransform: "matrix(22.92, 0, 0, -23.72, 602.31, 3953.82)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.94,92.49l-4.16.54a.9.9,0,0,0-.78,1s0,.07,0,.11l.83,3.28a.9.9,0,0,0,1,.67l3.46-.44a.92.92,0,0,0,.79-.93L130,93.35a.91.91,0,0,0-.9-.87h-.12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -32.05,
    y1: 159.81,
    x2: -32.05,
    y2: 159.81,
    gradientTransform: "matrix(15.5, 0, 0, -16.45, 496.84, 2724.37)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.6,62.76a35.73,35.73,0,0,1,.94,10.35,1.24,1.24,0,0,1-1.14,1.11c-.68,0-1.6.11-2.43.15a4.46,4.46,0,0,1-2.58-1,.42.42,0,0,0-.57.1.4.4,0,0,0,0,.42,5.08,5.08,0,0,0,1.47,1.59c.35.26,1.49.72,1.41,1.23a1,1,0,0,1-.23.43,5.18,5.18,0,0,1-2.54,1.46.73.73,0,0,0-.33.16c0,.62,1.86,1.3,2.35,1.46a5.6,5.6,0,0,0,2.26.26,6.71,6.71,0,0,0,4.66-3.08,33.24,33.24,0,0,0,4.65-13.19,6.85,6.85,0,0,0-5-1.86,10.74,10.74,0,0,0-2.93.41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -22.86,
    y1: 166.21,
    x2: -22.86,
    y2: 166.21,
    gradientTransform: "matrix(50.9, 0, 0, -46.8, 1163.74, 7849.7)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.74,45.76a44.88,44.88,0,0,1,9,17.47c1.53-.45,5.22-1.15,7.75,1.38,2-15.27-9.75-27-9.75-27Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -22.23,
    y1: 167.23,
    x2: -22.23,
    y2: 167.23,
    gradientTransform: "matrix(73.12, 0, 0, -64.2, 1625.63, 10786.95)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.3,44.91a.43.43,0,0,0-.07.61h0a44.52,44.52,0,0,1,8.92,17.3.44.44,0,0,0,.54.3.42.42,0,0,0,.3-.5A45.46,45.46,0,0,0,117.91,45a.43.43,0,0,0-.61-.07h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -22.29,
    y1: 165.38,
    x2: -22.29,
    y2: 165.38,
    gradientTransform: "matrix(45.83, 0, 0, -44.19, 1021.7, 7362.39)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.76,146.41c-1.27,3.94-1.11,6.35-.91,7.43l0,.08a52.19,52.19,0,0,0,9.84-.21.91.91,0,0,0,0-.23C30.57,149,25,146.24,25,146.24Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -8.31,
    y1: 168.46,
    x2: -8.31,
    y2: 168.46,
    gradientTransform: "matrix(23.06, 0, 0, -17.93, 274.04, 3253.11)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.88,153.92a.94.94,0,0,0,.7.71c2.6.55,6.73.11,8.47-.12a.81.81,0,0,0,.67-.8,52.19,52.19,0,0,1-9.84.21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -10.39,
    y1: 158.29,
    x2: -10.38,
    y2: 158.29,
    gradientTransform: "matrix(19.49, 0, 0, -16.3, 202.4, 2734.77)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.87,143.11l.94,4.52a.72.72,0,0,0,.63.6,5.86,5.86,0,0,0,1.45,0,.93.93,0,0,0,.74-1.09h0l-.66-4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -22.05,
    y1: 141.42,
    x2: -22.05,
    y2: 141.42,
    gradientTransform: "matrix(12.59, 0, 0, -9.94, 277.61, 1551.09)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,154a.49.49,0,0,0,.46.49l13.44-.09a.62.62,0,0,0,.56-.66.62.62,0,0,0-.07-.23c-1.76.15-6.25.47-10,.37a13.18,13.18,0,0,1-4.37-.63c0,.24,0,.49,0,.75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -14.31,
    y1: 162.23,
    x2: -14.3,
    y2: 162.23,
    gradientTransform: "matrix(27.58, 0, 0, -22.5, 394.59, 3803.88)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.94,153.24a13.18,13.18,0,0,0,4.37.63c3.78.1,8.27-.23,10-.37a.31.31,0,0,0-.05-.1A17.12,17.12,0,0,0,41.11,147l-2.87-.09a13.84,13.84,0,0,0-1.3,6.32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -12.74,
    y1: 168.21,
    x2: -12.74,
    y2: 168.21,
    gradientTransform: "matrix(32.45, 0, 0, -15.9, 495.86, 2906.5)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.58,142.71c.05.21.65,3.43.88,4.67a.62.62,0,0,0,.56.53,6.47,6.47,0,0,0,2-.15.86.86,0,0,0,.59-.89l-.32-5.09Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -24.25,
    y1: 142.94,
    x2: -24.25,
    y2: 142.94,
    gradientTransform: "matrix(14.32, 0, 0, -9.73, 347.32, 1535.86)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.22,89.58c-.17,20.62,3.8,49.24,4.49,54.05a1,1,0,0,0,.84.8,12.26,12.26,0,0,0,2.57,0,.69.69,0,0,0,.62-.73c-.67-14.78,1.42-43.29,1.42-43.29,1.81,6.71,8.72,37.2,9.69,42.88a1.19,1.19,0,0,0,1.13,1,14.44,14.44,0,0,0,3.21-.37,1.21,1.21,0,0,0,1-1.24c-2.84-32.23-6.78-59.3-6.78-59.3l-16.83-4.5s-1.36,9.55-1.37,10.72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -19.91,
    y1: 166.73,
    x2: -19.9,
    y2: 166.73,
    gradientTransform: "matrix(154.35, 0, 0, -76.32, 3072.42, 12836.77)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.21,34.42C14.2,47.38,16.73,78.9,17.26,84a1.12,1.12,0,0,0,.73.94,25,25,0,0,0,17.53-.17.89.89,0,0,0,.54-1.06c-1.7-6.36,2.14-14.8,4.32-25.14,1.81-8.54,5.85-14.73-1.7-20.64-4.16-3.26-6.31-4-7.4-4-.88,0-1.07.49-1.07.49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -19.58,
    y1: 167.91,
    x2: -19.58,
    y2: 167.91,
    gradientTransform: "matrix(139.65, 0, 0, -121.71, 2734.22, 20496.23)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.06,34.5s1.15,2.27,6.63,4.1l4.73-9.73-5-3.9c0,.45-6.4,9.53-6.4,9.53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -19.23,
    y1: 162.28,
    x2: -19.23,
    y2: 162.28,
    gradientTransform: "matrix(39.99, 0, 0, -39.6, 768.94, 6457.59)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.45,23.12c-.51,1.72,1.75,5.93,1.75,5.93a6.76,6.76,0,0,0,7.3,3.77c3.17-.56,2.58-2.34,2.43-5.08s-2.43-8-2.43-8-8.55,1.62-9,3.35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -20.36,
    y1: 162.49,
    x2: -20.36,
    y2: 162.49,
    gradientTransform: "matrix(41.6, 0, 0, -41.14, 847.05, 6712.05)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.2,14.17l-.14.25a.22.22,0,0,1-.29.1.26.26,0,0,1-.11-.14.2.2,0,0,0-.26-.14.16.16,0,0,0-.12.09c-.39.61-1.42,1.6-4.17,2.11-3.91.72-6.5,2.3-6.57,5a.21.21,0,0,1-.22.21.15.15,0,0,1-.11,0c-.29-.17-.75-.25-1.37.27-1.07.9-.63,3.24,1.72,5.17a.21.21,0,0,1,0,.3l-.05.05c-.43.28-1.06.94.59,1.82a5.55,5.55,0,0,0,3.47.76.22.22,0,0,0,.18-.25h0l-.52-2.38a.22.22,0,0,1,.16-.26h.87l.18-.08a.44.44,0,0,0,.22-.58v0c-.45-.86-1.32-2.85-.19-3.31,1.45-.59,7.2-1.77,8.44-3.81a3.79,3.79,0,0,0-1.45-5.21l-.1,0a.21.21,0,0,0-.19.11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -18.64,
    y1: 164.36,
    x2: -18.64,
    y2: 164.36,
    gradientTransform: "matrix(53.29, 0, 0, -52.97, 993.64, 8728.84)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,25.19c-1.5.93.78,3.74,2,3.86l.39-1.46S34.72,25,33.54,25a.92.92,0,0,0-.52.17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -21.87,
    y1: 143.47,
    x2: -21.86,
    y2: 143.47,
    gradientTransform: "matrix(12.45, 0, 0, -12.36, 272.21, 1800.01)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.55,52.51a34.63,34.63,0,0,0,3.58,1,36.09,36.09,0,0,1,3.56-7.18,17.52,17.52,0,0,1-7.58-5.68Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -18.85,
    y1: 161.22,
    x2: -18.85,
    y2: 161.22,
    gradientTransform: "matrix(32.65, 0, 0, -32.49, 615.63, 5284.21)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.69,46.34a36.09,36.09,0,0,0-3.56,7.18c17.24,3.8,21.3-12,21.3-12l-1.83-1c-6.45,7-11.67,7.38-15.91,5.88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -17.88,
    y1: 165.88,
    x2: -17.88,
    y2: 165.88,
    gradientTransform: "matrix(59.9, 0, 0, -55.4, 1071.31, 9239.33)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.49,39.17c-.86.73-2.08.25-3.46,0a2.38,2.38,0,0,0-2.12.55l4.17,1.65,2.57-1.95s-.16-.52-.58-.52a1,1,0,0,0-.58.27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -21.96,
    y1: 151.18,
    x2: -21.96,
    y2: 151.18,
    gradientTransform: "matrix(14.52, 0, 0, -14.82, 318.99, 2280.55)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.38,41.09c1.75,1.65,8.25,2.3,8.25,2.3l4.44-2.5c-.46-.94-3.13.6-3.13.6l1-1.29c-.59-.3-1.74.54-2.64.88S68,39.54,66.42,39.25a1.33,1.33,0,0,0-.28,0c-1.32,0-1.76,1.86-1.76,1.86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -17.54,
    y1: 158.38,
    x2: -17.54,
    y2: 158.38,
    gradientTransform: "matrix(29.78, 0, 0, -21.15, 522.49, 3390.6)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,56.16s12.13,10.16,25.24,5.73a3.1,3.1,0,0,1,2.46.19l3.76,2a3.38,3.38,0,0,0,4.46-1.25A7.25,7.25,0,0,0,70.93,60l-7.38-3,.55-.9s-3.6-.31-4.54,2.27c0,0-6.86,2.85-18.42-9.86,0,0-5.24,4.46-7.2,7.65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -20.39,
    y1: 167.37,
    x2: -19.95,
    y2: 167.37,
    gradientTransform: "matrix(67.75, 0, 0, -92.25, 1419.14, 15498.2)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.75,46.67a.21.21,0,0,0-.11.27h0A23.39,23.39,0,0,0,33.18,56a.15.15,0,0,0,.11,0,.21.21,0,0,0,.21-.21.2.2,0,0,0-.09-.17A23.08,23.08,0,0,1,26,46.78a.2.2,0,0,0-.27-.11h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -20.18,
    y1: 158.28,
    x2: -20.17,
    y2: 158.28,
    gradientTransform: "matrix(27.42, 0, 0, -26.32, 553.15, 4217.24)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67",
    transform: "translate(82.37 81.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.65,37.65a.21.21,0,0,0,.2.36,7,7,0,0,1,4.76-.63,6,6,0,0,1,3.57,3.08c3,5.32,4.53,7.75,4.55,7.78a.2.2,0,0,0,.17.09l.12,0a.22.22,0,0,0,.06-.29h0s-1.57-2.44-4.54-7.75A6.4,6.4,0,0,0,32.72,37a5.77,5.77,0,0,0-1.6-.22,7.64,7.64,0,0,0-3.47.89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -20.41,
    y1: 162.42,
    x2: -20.41,
    y2: 162.42,
    gradientTransform: "matrix(38.39, 0, 0, -39.88, 783.51, 6519.87)",
    xlinkHref: "#linear-gradient-19"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    className: "cls-4",
    x: -35.89,
    y: -34.73,
    width: 231.1,
    height: 229.72,
    transform: "translate(49.73 149.45) rotate(-38.83)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    className: "cls-7",
    d: "M34.18,51.21a.73.73,0,0,1,1-.16h0c.63.46,1.28.91,2,1.31a.73.73,0,0,1,.25,1h0a.73.73,0,0,1-1,.24h0c-.7-.43-1.39-.89-2.05-1.38a.73.73,0,0,1-.19-.95.21.21,0,0,1,0-.06m6.34,2.92c.72.31,1.45.6,2.19.85a.72.72,0,0,1-.45,1.37h0c-.77-.26-1.55-.57-2.3-.9a.71.71,0,0,1-.37-1,.3.3,0,0,1,0-.08.72.72,0,0,1,.91-.29M46.39,56c.77.14,1.55.26,2.33.34a.72.72,0,0,1-.15,1.44c-.82-.08-1.64-.2-2.45-.36A.72.72,0,0,1,46.39,56h0m6.14.46c.78,0,1.56-.09,2.34-.19A.73.73,0,0,1,55,57.66c-.81.1-1.64.17-2.46.2a.73.73,0,1,1,0-1.45m6.08-.91c.75-.2,1.5-.44,2.24-.7a.72.72,0,0,1,.93.43.74.74,0,0,1-.43.93h0c-.77.28-1.57.53-2.36.74a.73.73,0,0,1-.39-1.4h0m5.73-2.24c.69-.36,1.37-.76,2-1.18a.72.72,0,0,1,1,.22.73.73,0,0,1-.22,1c-.69.44-1.41.86-2.14,1.24a.72.72,0,1,1-.67-1.28M79.67,31.15a.73.73,0,0,1,.65.8h0c-.09.81-.21,1.63-.37,2.44a.72.72,0,0,1-1.42-.27c.15-.77.26-1.55.34-2.32a.74.74,0,0,1,.8-.65h0M69.42,49.81c.6-.51,1.17-1,1.72-1.6a.72.72,0,0,1,1,0,.73.73,0,0,1,0,1c-.57.58-1.18,1.15-1.8,1.68a.74.74,0,0,1-1-.07.73.73,0,0,1,.07-1h0m9-12.46a.72.72,0,0,1,.45.92h0c-.26.78-.57,1.55-.9,2.3A.72.72,0,0,1,76.7,40h0c.31-.72.6-1.45.85-2.19a.72.72,0,0,1,.92-.45m-4.86,8c.46-.62.91-1.28,1.32-1.94a.72.72,0,0,1,1.24.74v0c-.43.7-.9,1.38-1.38,2a.71.71,0,0,1-1,.17.72.72,0,0,1-.2-1l0-.06",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    className: "cls-7",
    d: "M79,26.42a.68.68,0,0,0-.1.42c0,.37,0,.75.06,1.13a.73.73,0,0,0,.74.71.72.72,0,0,0,.71-.73v0c0-.39,0-.79-.07-1.18A.72.72,0,0,0,79,26.42",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    className: "cls-7",
    d: "M68.87,6.81a.72.72,0,0,0,.16.92l.86.74a.73.73,0,0,0,1-.06.72.72,0,0,0-.06-1h0q-.43-.4-.9-.78a.73.73,0,0,0-1,.1l-.06.1",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    className: "cls-7",
    d: "M27.33,13.06a.72.72,0,0,1,1-.21.73.73,0,0,1,.21,1c-.42.64-.81,1.3-1.18,2a.73.73,0,0,1-1.28-.7c.16-.29.33-.58.5-.87s.49-.82.75-1.21m-2,5.25a.73.73,0,0,1,.43.94c-.27.71-.52,1.45-.73,2.19a.71.71,0,0,1-.88.51.72.72,0,0,1-.52-.88v0c.22-.77.48-1.55.76-2.3a.72.72,0,0,1,.93-.43m4.34-8.4c.53-.61,1.09-1.2,1.67-1.76a.73.73,0,0,1,1,0,.74.74,0,0,1,0,1c-.55.53-1.09,1.09-1.59,1.67a.72.72,0,0,1-1,.07.73.73,0,0,1-.07-1m-6,14.38a.72.72,0,0,1,.62.82h0c-.1.76-.18,1.53-.22,2.3a.73.73,0,0,1-.77.68.73.73,0,0,1-.68-.76c.05-.81.13-1.62.24-2.42a.72.72,0,0,1,.81-.62h0M34.4,5.6c.65-.47,1.33-.93,2-1.35a.72.72,0,1,1,.79,1.21l0,0c-.66.39-1.3.83-1.92,1.28a.72.72,0,1,1-.86-1.16h0m5.51-3.17c.74-.33,1.51-.62,2.27-.88a.72.72,0,1,1,.48,1.36h0c-.73.25-1.45.53-2.16.83a.72.72,0,0,1-1-.35.74.74,0,0,1,.36-1h0M46,.53c.79-.16,1.6-.28,2.4-.37a.74.74,0,0,1,.8.65.73.73,0,0,1-.64.79h0c-.76.09-1.53.2-2.29.35A.72.72,0,1,1,46,.53M52.35,0c.81,0,1.62.08,2.42.17a.72.72,0,1,1-.14,1.44h0c-.76-.09-1.54-.14-2.3-.16A.73.73,0,0,1,51.6.7a.73.73,0,0,1,.75-.7m6.31.88c.78.2,1.56.44,2.33.7a.73.73,0,0,1,.45.92.74.74,0,0,1-.93.45h0c-.72-.25-1.47-.47-2.21-.66a.73.73,0,0,1-.53-.88.72.72,0,0,1,.88-.53h0m6,2.25c.53.27,1.06.55,1.57.85l.55.34a.72.72,0,0,1,.25,1h0a.73.73,0,0,1-1,.24h0l-.52-.32C65,5,64.47,4.67,64,4.42a.72.72,0,0,1-.32-1h0a.05.05,0,0,1,0,0,.71.71,0,0,1,1-.28",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    className: "cls-7",
    d: "M22.78,30.87a.72.72,0,0,0-.1.43c0,.39.07.78.12,1.18a.72.72,0,1,0,1.44-.16v0c0-.37-.09-.75-.12-1.12a.71.71,0,0,0-.78-.66.71.71,0,0,0-.57.35",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    className: "cls-7",
    d: "M32.24,38.91a.32.32,0,0,0,.33.22L36.69,39a18,18,0,0,0,4,4.26l-.4,4.1a.33.33,0,0,0,.19.34l4.5,2.06a.32.32,0,0,0,.38-.08l2.85-3A17.71,17.71,0,0,0,54,47l2.62,3.19a.34.34,0,0,0,.38.1l4.63-1.72a.34.34,0,0,0,.22-.33l-.1-4.12a17.87,17.87,0,0,0,4.27-4l4.09.4a.34.34,0,0,0,.35-.19l2-4.5a.34.34,0,0,0-.07-.38l-3-2.85a18,18,0,0,0,.21-5.81l3.18-2.62a.33.33,0,0,0,.11-.38l-1.73-4.63a.32.32,0,0,0-.32-.22l-4.12.1a18.07,18.07,0,0,0-4-4.27l.4-4.1a.35.35,0,0,0-.2-.34L58.52,8.26a.34.34,0,0,0-.39.08l-2.84,3a17.72,17.72,0,0,0-5.81-.21L46.86,7.92a.34.34,0,0,0-.38-.1L41.85,9.55a.33.33,0,0,0-.23.32l.1,4.12a18.22,18.22,0,0,0-4.26,4l-4.1-.4a.35.35,0,0,0-.34.2L31,22.24a.34.34,0,0,0,.08.39l3,2.84a17.72,17.72,0,0,0-.21,5.81L30.62,33.9a.34.34,0,0,0-.1.38Z",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    className: "cls-9",
    d: "M47.85,25.92a5,5,0,1,1-.41.6,4.89,4.89,0,0,1,.41-.6m7.66,2.7a3.79,3.79,0,1,0-.81,2.8A4.87,4.87,0,0,0,55,31a3.72,3.72,0,0,0,.49-2.33",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    className: "cls-9",
    d: "M41.3,22.8a11.7,11.7,0,0,0-.58,1.11l-.16.37A11.9,11.9,0,0,0,40,26.14v0l0,.08,0,.14a.29.29,0,0,0,.57.13,11.64,11.64,0,0,1,16.22-8.09c.36.17.71.35,1.06.55A11.64,11.64,0,1,1,42.24,35.6l-.09-.09a.29.29,0,0,0-.39.41A12.22,12.22,0,1,0,58,18.47c-.36-.21-.73-.4-1.11-.58A12.22,12.22,0,0,0,41.3,22.8",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    className: "cls-7",
    d: "M5.16,62.94a.45.45,0,0,0,.06.53q.39.42.81.81a.44.44,0,0,0,.63,0,.46.46,0,0,0,0-.64h0l-.77-.77a.44.44,0,0,0-.63,0,.39.39,0,0,0-.08.1",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    className: "cls-7",
    d: "M7.76,65.18a.45.45,0,0,1,.63-.09,18.45,18.45,0,0,0,1.57,1l.34.19a.45.45,0,0,1-.43.78,3.07,3.07,0,0,1-.36-.2,18,18,0,0,1-1.65-1.08.44.44,0,0,1-.12-.59s0,0,0,0m4.59,2.12A20.14,20.14,0,0,0,14.5,68a.44.44,0,0,1,.33.54.45.45,0,0,1-.54.33h0A20,20,0,0,1,12,68.13a.45.45,0,0,1-.24-.59.44.44,0,0,1,.58-.24m4.38,1.18a17.21,17.21,0,0,0,2.26.18.45.45,0,0,1,.43.47.44.44,0,0,1-.44.42,19.06,19.06,0,0,1-2.38-.18.45.45,0,1,1,.13-.89m4.54.07a18.54,18.54,0,0,0,2.23-.38.45.45,0,0,1,.54.34.44.44,0,0,1-.33.53,18.6,18.6,0,0,1-2.35.4.44.44,0,0,1-.48-.4.45.45,0,0,1,.39-.49m4.41-1a19.32,19.32,0,0,0,2.08-.92.45.45,0,0,1,.44.78l0,0a21.19,21.19,0,0,1-2.18,1,.45.45,0,0,1-.57-.27.44.44,0,0,1,.26-.57h0m4-2.08A16.24,16.24,0,0,0,31.5,64a.45.45,0,0,1,.63.06.46.46,0,0,1,0,.62,22,22,0,0,1-1.88,1.46.46.46,0,0,1-.63-.1.44.44,0,0,1,.1-.62l0,0m3.4-3a20,20,0,0,0,1.4-1.79.44.44,0,0,1,.62-.12.46.46,0,0,1,.12.62A17.91,17.91,0,0,1,33.78,63a.44.44,0,0,1-.63,0,.45.45,0,0,1,0-.61m4-6.09a.44.44,0,0,1,.27.58h0a18.76,18.76,0,0,1-.82,1.9c0,.09-.09.19-.14.28a.44.44,0,0,1-.6.19h0a.44.44,0,0,1-.19-.6l.14-.27a19.35,19.35,0,0,0,.78-1.81.45.45,0,0,1,.57-.27h0",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    className: "cls-7",
    d: "M2.76,40.22A18.43,18.43,0,0,1,4.1,38.29a.44.44,0,0,1,.63-.06.45.45,0,0,1,.07.61,19.39,19.39,0,0,0-1.27,1.84.45.45,0,0,1-.62.14.46.46,0,0,1-.15-.6h0m-.49,1.85a.45.45,0,0,1,.22.59,19.55,19.55,0,0,0-.8,2.09.44.44,0,0,1-.56.28.46.46,0,0,1-.29-.55,20.05,20.05,0,0,1,.83-2.19l0,0a.44.44,0,0,1,.57-.18m3.38-5.54A18.58,18.58,0,0,1,7.41,35a.44.44,0,0,1,.62.09.45.45,0,0,1-.07.62,18.14,18.14,0,0,0-1.68,1.48.45.45,0,0,1-.63,0,.45.45,0,0,1,0-.64M.8,46.4a.45.45,0,0,1,.36.52,18.19,18.19,0,0,0-.27,2.22.45.45,0,0,1-.44.45A.45.45,0,0,1,0,49.14v0a20.29,20.29,0,0,1,.28-2.33A.44.44,0,0,1,.8,46.4M9.34,33.66a18.5,18.5,0,0,1,2.07-1.08.46.46,0,0,1,.6.22.44.44,0,0,1-.23.59,18.66,18.66,0,0,0-2,1,.47.47,0,0,1-.62-.16.45.45,0,0,1,.16-.61m4.27-1.91a19.91,19.91,0,0,1,2.28-.55.44.44,0,0,1,.52.36.46.46,0,0,1-.37.52,18.06,18.06,0,0,0-2.17.53.45.45,0,1,1-.29-.85h0m4.6-.83a20.47,20.47,0,0,1,2.35,0,.45.45,0,0,1,.4.49.44.44,0,0,1-.46.4,18.6,18.6,0,0,0-2.24,0,.46.46,0,0,1-.47-.43h0a.57.57,0,0,1,.06-.25.45.45,0,0,1,.36-.22",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    className: "cls-7",
    d: "M.07,51.2a.36.36,0,0,0-.06.25c0,.38.06.77.1,1.14A.46.46,0,0,0,.59,53,.45.45,0,0,0,1,52.53s0,0,0-.05c0-.35-.08-.72-.1-1.08A.45.45,0,0,0,.42,51a.44.44,0,0,0-.35.22",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    className: "cls-7",
    d: "M6.4,56.9a.23.23,0,0,0,.21.15L9.37,57A12,12,0,0,0,12,59.84l-.27,2.74a.23.23,0,0,0,.14.23l3,1.37a.23.23,0,0,0,.26-.05l1.9-2a12.39,12.39,0,0,0,3.89.14l1.75,2.13a.26.26,0,0,0,.26.07l3.1-1.16a.23.23,0,0,0,.15-.22l-.07-2.75A12,12,0,0,0,29,57.7l2.75.27a.25.25,0,0,0,.23-.14l1.37-3a.21.21,0,0,0,0-.25l-2-1.91a12.09,12.09,0,0,0,.15-3.89L33.56,47a.21.21,0,0,0,.06-.25l-1.15-3.1a.23.23,0,0,0-.22-.15l-2.75.07a12.23,12.23,0,0,0-2.65-2.86L27.11,38a.22.22,0,0,0-.13-.23l-3-1.37a.23.23,0,0,0-.26,0l-1.9,2a12.38,12.38,0,0,0-3.89-.14l-1.75-2.13a.23.23,0,0,0-.25-.07l-3.1,1.16a.23.23,0,0,0-.15.22l.07,2.75a12.23,12.23,0,0,0-2.86,2.65l-2.74-.26a.22.22,0,0,0-.23.13l-1.37,3a.21.21,0,0,0,0,.25l2,1.91a12.09,12.09,0,0,0-.14,3.89L5.31,53.55a.23.23,0,0,0-.07.25Z",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    className: "cls-9",
    d: "M16.8,48.17a3.33,3.33,0,1,1-.29.41,3.81,3.81,0,0,1,.29-.41m4.19.18a2.49,2.49,0,1,0,.39,3.5,2.49,2.49,0,0,0-.39-3.5h0",
    transform: "translate(82.37 81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    className: "cls-9",
    d: "M12.23,46c-.14.24-.27.5-.39.76a8.48,8.48,0,0,0-.56,1.63v.07a.45.45,0,0,0,.34.54.45.45,0,0,0,.53-.35,8.23,8.23,0,0,1,.51-1.52h0l0-.08A7.44,7.44,0,0,1,15,44.2a7.7,7.7,0,0,1,1.78-1h0l.05,0a7.48,7.48,0,0,1,5.76.21c.24.11.46.23.69.36a7.54,7.54,0,1,1-10,10.76.35.35,0,0,0-.14-.13.43.43,0,0,0-.61.16.46.46,0,0,0,0,.48,8.43,8.43,0,0,0,13.89-9.56A8.3,8.3,0,0,0,23.78,43a7,7,0,0,0-.77-.4A8.44,8.44,0,0,0,12.23,46",
    transform: "translate(82.37 81.8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    className: "cls-13",
    x: -2.26,
    y: 13.77,
    width: 168.26,
    height: 162.76,
    transform: "translate(51.08 122.61) rotate(-23.64)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    className: "cls-7",
    d: "M128.73,90.11c0,26.25-22.53,47.54-50.32,47.54S28.09,116.36,28.09,90.11,50.62,42.57,78.41,42.57s50.32,21.28,50.32,47.54",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    className: "cls-19",
    d: "M98.26,94.68A178.55,178.55,0,0,1,95.68,126c-.46,2.58-1,5.15-1.65,7.69a76.07,76.07,0,0,1-2.31,7.53,35.84,35.84,0,0,1-3.45,7.1,14.32,14.32,0,0,1-2.59,3A7.18,7.18,0,0,1,84,152.41a5,5,0,0,1-2,.47,4.9,4.9,0,0,1-2-.37,6.6,6.6,0,0,1-1.73-1,13.38,13.38,0,0,1-2.65-3,34.69,34.69,0,0,1-3.49-7.07,70.36,70.36,0,0,1-2.34-7.52c-.65-2.54-1.2-5.11-1.67-7.69-.94-5.16-1.58-10.37-2-15.59s-.64-10.47-.67-15.71c0-2.62.06-5.24.15-7.86s.25-5.24.44-7.85c.39-5.23,1-10.44,1.83-15.62.43-2.58.93-5.16,1.54-7.71a70.79,70.79,0,0,1,2.19-7.55c.44-1.24.92-2.46,1.47-3.66a27,27,0,0,1,1.88-3.47,12.93,12.93,0,0,1,2.58-3,6.74,6.74,0,0,1,1.71-1,4.94,4.94,0,0,1,2-.35,5,5,0,0,1,1.94.46,7,7,0,0,1,1.69,1,14.21,14.21,0,0,1,2.64,2.94,35.32,35.32,0,0,1,3.63,7,73.42,73.42,0,0,1,2.48,7.47c.7,2.53,1.29,5.09,1.8,7.66a164.08,164.08,0,0,1,2.89,31.27m-.78,0q0-7.83-.62-15.64a150.29,150.29,0,0,0-2-15.53c-.48-2.56-1-5.11-1.71-7.63a71.75,71.75,0,0,0-2.39-7.45,35.22,35.22,0,0,0-3.51-7,13.83,13.83,0,0,0-2.55-2.9,7.32,7.32,0,0,0-1.62-1,4.93,4.93,0,0,0-1.85-.45,4.45,4.45,0,0,0-1.87.35,6.5,6.5,0,0,0-1.63,1,12.55,12.55,0,0,0-2.49,3,27.06,27.06,0,0,0-1.82,3.45c-.53,1.19-1,2.41-1.42,3.64A72.35,72.35,0,0,0,69.88,56c-.58,2.55-1,5.12-1.45,7.69-.8,5.16-1.32,10.37-1.65,15.58s-.45,10.43-.44,15.66.17,10.43.55,15.65,1,10.39,1.89,15.54q.66,3.85,1.6,7.65a71.59,71.59,0,0,0,2.26,7.48,34.27,34.27,0,0,0,3.39,7,13.14,13.14,0,0,0,2.53,2.89,6.67,6.67,0,0,0,1.62,1,4.55,4.55,0,0,0,1.83.35,4.78,4.78,0,0,0,1.81-.45,6.86,6.86,0,0,0,1.58-1A13.68,13.68,0,0,0,87.88,148a35,35,0,0,0,3.34-7,71.62,71.62,0,0,0,2.23-7.49c.63-2.53,1.15-5.09,1.59-7.66.89-5.14,1.48-10.34,1.88-15.54s.58-10.43.58-15.65",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    className: "cls-19",
    d: "M124.7,94.68a76.85,76.85,0,0,1-2.71,20A64.54,64.54,0,0,1,113.62,133a52.84,52.84,0,0,1-6.4,7.83,44.54,44.54,0,0,1-7.87,6.34,38.14,38.14,0,0,1-9.18,4.2,34.28,34.28,0,0,1-20,0A37.79,37.79,0,0,1,61,147.21a44.46,44.46,0,0,1-7.88-6.33,53.35,53.35,0,0,1-6.41-7.82,64.71,64.71,0,0,1-8.39-18.36,71.21,71.21,0,0,1-2-9.92,74.67,74.67,0,0,1,0-20.2,73,73,0,0,1,2-9.92,64.31,64.31,0,0,1,8.41-18.33,52.25,52.25,0,0,1,6.4-7.82A44.41,44.41,0,0,1,61,42.19,37.87,37.87,0,0,1,70.22,38a34.13,34.13,0,0,1,19.94,0,38.18,38.18,0,0,1,9.17,4.18,44.48,44.48,0,0,1,7.87,6.33,51.58,51.58,0,0,1,6.39,7.82A64.23,64.23,0,0,1,122,74.68a76.37,76.37,0,0,1,2.73,20m-.89,0a75.63,75.63,0,0,0-2.6-19.79,64.21,64.21,0,0,0-8.11-18.22,52.13,52.13,0,0,0-6.25-7.8,43.52,43.52,0,0,0-7.72-6.34,37,37,0,0,0-9.07-4.19,33.19,33.19,0,0,0-19.73,0,36.78,36.78,0,0,0-9.06,4.2,43.09,43.09,0,0,0-7.72,6.34,51.64,51.64,0,0,0-6.24,7.81,64,64,0,0,0-8.08,18.21,72.58,72.58,0,0,0-1.94,9.8,76.5,76.5,0,0,0,0,19.94,72.64,72.64,0,0,0,2,9.8,63.92,63.92,0,0,0,8.09,18.2,51,51,0,0,0,6.24,7.8,43.32,43.32,0,0,0,7.71,6.33A37.37,37.37,0,0,0,70.34,151a33,33,0,0,0,19.71,0,37.33,37.33,0,0,0,9-4.17,43.53,43.53,0,0,0,7.73-6.33,52,52,0,0,0,6.25-7.79,64.18,64.18,0,0,0,8.12-18.21,75.58,75.58,0,0,0,2.61-19.79",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    className: "cls-19",
    d: "M28.26,71.65l13.36-.11L55,71.48l26.73,0,26.73.06,13.37.06,13.36.12a0,0,0,0,1,0,.08l-13.36.12-13.37.06L81.72,72,55,71.94l-13.37-.06-13.36-.11a.06.06,0,0,1,0-.12",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    className: "cls-19",
    d: "M43.76,49.27c3.17-.05,6.33-.08,9.49-.11l9.49-.06c3.16,0,6.33,0,9.49,0l9.49,0,19,.05,9.49.07c3.16,0,6.32.06,9.49.11,0,0,0,0,0,0s0,0,0,0c-3.17.06-6.33.08-9.49.12l-9.49.07-19,.05-9.49,0c-3.16,0-6.33,0-9.49,0l-9.49-.06c-3.16,0-6.32-.06-9.49-.11a.06.06,0,0,1,0-.06,0,0,0,0,1,0,0",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    className: "cls-19",
    d: "M23.61,94l14.53-.11,14.52-.06,29.06-.05,29.05.05,14.53.07,14.52.12s0,0,0,0a0,0,0,0,1,0,0l-14.52.11-14.53.07-29,.05-29.06-.05-14.52-.06-14.53-.11a.06.06,0,0,1-.06-.05.06.06,0,0,1,.06-.06",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    className: "cls-19",
    d: "M28.26,116.42l13.36-.1L55,116.25l26.73,0,26.73.05,13.37.07,13.36.11a0,0,0,1,1,0,.08l-13.36.12-13.37.06-26.73.06L55,116.71l-13.37-.06-13.36-.11a.06.06,0,0,1,0-.12",
    transform: "translate(82.37 81.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    className: "cls-19",
    d: "M121.59,139.07H45.68a.2.2,0,0,1-.22-.19.21.21,0,0,1,.2-.22h75.93a.21.21,0,0,1,.21.2.19.19,0,0,1-.19.21h0",
    transform: "translate(82.37 81.8)"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    className: "cls-27",
    x: 60.75,
    y: 59.37,
    width: 5.56,
    height: 5.36,
    transform: "translate(71.61 95.19) rotate(-11.1)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    className: "cls-29",
    x: 61.57,
    y: 51.8,
    width: 22.19,
    height: 10.87,
    transform: "translate(74.83 92.94) rotate(-8.34)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    className: "cls-31",
    x: 76.4,
    y: 34.09,
    width: 29.51,
    height: 27.9,
    transform: "translate(91.28 191.92) rotate(-64.84)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    className: "cls-33",
    x: 87.68,
    y: 30.92,
    width: 63.42,
    height: 58.56,
    transform: "matrix(0.43, -0.91, 0.91, 0.43, 96.51, 224.46)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    className: "cls-35",
    x: 101.2,
    y: 25.82,
    width: 14.84,
    height: 13.42,
    transform: "translate(77.66 117.81) rotate(-18.43)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    className: "cls-37",
    x: 98.03,
    y: 17.19,
    width: 16.17,
    height: 15.54,
    transform: "translate(123.29 194.12) rotate(-66.5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    className: "cls-39",
    x: 94.48,
    y: 11.57,
    width: 25.28,
    height: 25.39,
    transform: "translate(94.86 161.82) rotate(-43.27)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    className: "cls-41",
    x: 107.64,
    y: 26.16,
    width: 6.43,
    height: 6.47,
    transform: "translate(122.06 201.13) rotate(-66.5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    className: "cls-43",
    x: 116.38,
    y: 146.55,
    width: 1.81,
    height: 15.39,
    transform: "translate(44.2 351.71) rotate(-89.4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    className: "cls-45",
    x: 109.61,
    y: 146.23,
    width: 15.94,
    height: 9.95,
    transform: "matrix(0.96, -0.27, 0.27, 0.96, 45.43, 119.82)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    className: "cls-47",
    x: 201.64,
    y: 226.18,
    width: 4.29,
    height: 5.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    className: "cls-49",
    x: 151.4,
    y: 150.85,
    width: 2.22,
    height: 5.99,
    transform: "translate(79.45 386.53) rotate(-89.4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    className: "cls-51",
    x: 144.22,
    y: 142.9,
    width: 13.29,
    height: 12.97,
    transform: "translate(25.71 276.03) rotate(-56.91)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    className: "cls-53",
    x: 228.11,
    y: 222.2,
    width: 5.23,
    height: 6.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    className: "cls-55",
    x: 94.7,
    y: 73.35,
    width: 72.44,
    height: 78.66,
    transform: "matrix(0.81, -0.59, 0.59, 0.81, 41.17, 179.9)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    className: "cls-57",
    x: 107.01,
    y: 85.85,
    width: 39.78,
    height: 24.91,
    transform: "translate(70.17 99.99) rotate(-7.82)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    className: "cls-19",
    d: "M115.05,107.27a.06.06,0,0,1-.06-.06.07.07,0,0,1,.05-.07l.52-.06a.08.08,0,0,1,.07,0h0a.07.07,0,0,1-.06.07l-.51.06h0m-1.2,0h0a2.83,2.83,0,0,1-.5-.13.05.05,0,0,1,0-.08h0s0,0,.08,0a3.92,3.92,0,0,0,.49.13.08.08,0,0,1,0,.08.08.08,0,0,1-.07,0m2.91-.17a.07.07,0,1,1,0-.13l.51-.06a.05.05,0,0,1,.07.05h0a.05.05,0,0,1,0,.07h0l-.51.07h0m1.71-.21a.07.07,0,0,1-.07-.06.06.06,0,0,1,.06-.07l.51-.06a.06.06,0,0,1,.07,0h0a.07.07,0,0,1-.05.08h0l-.52.06h0m1.7-.21a.06.06,0,0,1-.06-.06.07.07,0,0,1,0-.07l.52-.06s.06,0,.07.05h0a.07.07,0,0,1-.06.07l-.51.06h0m-7.87-.11,0,0a3.17,3.17,0,0,1-.39-.34.06.06,0,0,1,0-.09.06.06,0,0,1,.08,0,3.9,3.9,0,0,0,.38.33.06.06,0,0,1,0,.09.05.05,0,0,1,0,0m9.58-.1a.06.06,0,0,1-.06-.06.06.06,0,0,1,.05-.06l.51-.07s.07,0,.07.06h0a.06.06,0,0,1,0,.07h0l-.51.06h0m1.71-.2a.07.07,0,0,1-.07-.07.06.06,0,0,1,.06-.06l.51-.07a.07.07,0,0,1,.07.06h0a.05.05,0,0,1,0,.07l-.52.07h0m1.7-.21a.07.07,0,0,1-.06-.07.06.06,0,0,1,0-.06l.52-.06s.06,0,.07,0h0s0,.07-.06.07l-.51.07h0m1.71-.21a.07.07,0,1,1,0-.13l.51-.06a.05.05,0,0,1,.07.05h0a.09.09,0,0,1-.06.08h0l-.51.06h0m1.71-.21a.07.07,0,0,1-.07-.06.07.07,0,0,1,.06-.07l.51-.06a.06.06,0,0,1,.07,0h0s0,.06-.05.07l-.52.06h0m1.7-.21a.06.06,0,0,1-.06-.06.07.07,0,0,1,.06-.07l.51-.06a.07.07,0,0,1,.07.06h0a.07.07,0,0,1-.06.07h0l-.51.06h0m-19.19-.18a.07.07,0,0,1-.06,0,4.94,4.94,0,0,1-.19-.49.05.05,0,0,1,0-.08.06.06,0,0,1,.08,0,2.72,2.72,0,0,0,.19.47.06.06,0,0,1,0,.08h0m20.9,0a.06.06,0,0,1-.07-.06.09.09,0,0,1,.06-.07h0l.51-.06a.08.08,0,0,1,.08,0h0a.07.07,0,0,1-.06.07h0l-.51.06h0m1.71-.21a.06.06,0,0,1-.07-.06.06.06,0,0,1,.06-.06l.51-.07s.07,0,.07.06h0a.06.06,0,0,1-.05.07h0l-.52.06h0m1.7-.2a.09.09,0,0,1-.06-.07.06.06,0,0,1,.06-.06l.51-.07a.07.07,0,0,1,.07.06h0s0,.07-.06.07h0l-.51.06h0m1.71-.2a.07.07,0,0,1-.06-.07.06.06,0,0,1,0-.06l.52-.06s.06,0,.07.05h0s0,.07-.06.07h0l-.51.07h0m1.71-.21a.07.07,0,0,1-.07-.06s0-.07.06-.07l.51-.06a.06.06,0,1,1,0,.12h0l-.51.07h0m1.7-.21a.06.06,0,0,1-.06-.06.06.06,0,0,1,.06-.07h0l.51-.06a.06.06,0,0,1,.07.05h0a.08.08,0,0,1-.06.08l-.51.06h0m1.71-.21s-.07,0-.07-.06a.07.07,0,0,1,.06-.07,2.72,2.72,0,0,0,.49-.13.07.07,0,0,1,.08,0,.07.07,0,0,1,0,.07,2.73,2.73,0,0,1-.51.14h0m-31.57-.38a.06.06,0,0,1-.06-.06l-.08-.51s0-.06,0-.07a.07.07,0,0,1,.08,0h0l.08.51a.08.08,0,0,1-.06.08h0m33.07-.41s-.06,0-.06-.07a0,0,0,0,1,0,0,3,3,0,0,0,.31-.39.07.07,0,0,1,.11.07,2.69,2.69,0,0,1-.33.41l0,0m-33.34-1.29a.06.06,0,0,1-.06,0l-.08-.51a.07.07,0,0,1,.05-.08h0a.08.08,0,0,1,.08,0h0l.08.51a.07.07,0,0,1-.06.07h0m34.08-.23h0a.07.07,0,0,1-.06-.07h0c0-.1,0-.19,0-.28v-.23a.06.06,0,0,1,.06-.06h0a.07.07,0,0,1,.07.06h0v.23a2.64,2.64,0,0,1,0,.29.06.06,0,0,1-.06.06m-34.35-1.47a.06.06,0,0,1-.06,0l-.09-.51a.08.08,0,0,1,.05-.08.07.07,0,0,1,.08,0h0l.08.51a.06.06,0,0,1,0,.07h0m34.38-.25a.07.07,0,0,1-.07-.06v-.52a.06.06,0,0,1,.06-.06h0s.07,0,.07.06v.52a.06.06,0,0,1-.06.06ZM110,98.46a.07.07,0,0,1-.07,0l-.08-.51a.06.06,0,0,1,0-.07h0a.06.06,0,0,1,.08,0h0l.08.51a.06.06,0,0,1-.05.07h0m34.62-.27a.07.07,0,0,1-.07-.06c0-.17,0-.34,0-.52,0,0,0-.06.06-.06h0a.07.07,0,0,1,.07.06c0,.17,0,.34,0,.51s0,.07-.06.07Zm-34.9-1.43a.06.06,0,0,1-.06-.05l-.08-.51a.06.06,0,0,1,0-.07h0a.05.05,0,0,1,.07.05h0l.08.51a.07.07,0,0,1-.06.07h0m34.82-.29a.06.06,0,0,1-.06-.06c0-.17,0-.34,0-.51a.07.07,0,0,1,.06-.07s.07,0,.07.06h0l0,.51a.06.06,0,0,1-.06.07h0m-35.09-1.4a.06.06,0,0,1-.06-.06l-.08-.51a.05.05,0,0,1,0-.07h0a.06.06,0,0,1,.07,0h0l.08.51a.06.06,0,0,1,0,.08h0m35-.32a.07.07,0,0,1-.07,0c0-.17,0-.34,0-.52a.09.09,0,0,1,.06-.07s.07,0,.07.06,0,.34,0,.51a.06.06,0,0,1-.06.07h0m-35.23-1.38a.09.09,0,0,1-.07-.06L109,92.8a.07.07,0,0,1,.06-.07s.06,0,.07,0h0l.08.51a.07.07,0,0,1,0,.08h0m35-.33a.08.08,0,0,1-.07-.05l-.06-.51a.07.07,0,0,1,.05-.08s.07,0,.07.06h0c0,.17.05.34.07.51a.05.05,0,0,1,0,.07h0m-34.28-.29s-.07,0-.07-.06a.07.07,0,0,1,.06-.07l.51-.07a.08.08,0,0,1,.08,0h0a.07.07,0,0,1-.06.07h0l-.51.07h0m1.71-.22a.07.07,0,0,1-.07-.06s0-.07.06-.07h0l.51-.07a.07.07,0,0,1,.07.06h0a.05.05,0,0,1,0,.07l-.52.07h0m1.7-.22a.07.07,0,0,1-.06-.07.06.06,0,0,1,0-.06l.52-.06s.06,0,.07,0h0s0,.07-.06.07l-.51.07h0m1.71-.22s-.07,0-.07-.06,0-.07.06-.07h0l.51-.06a.05.05,0,0,1,.07,0h0a.05.05,0,0,1,0,.07l-.51.07h0m1.7-.22a.07.07,0,0,1-.07-.06.07.07,0,0,1,.06-.07l.52-.06s.06,0,.07,0h0s0,.07-.06.07h0l-.51.07h0m1.71-.22a.06.06,0,0,1-.06-.07.06.06,0,0,1,0-.06l.51-.06a.05.05,0,0,1,.07.05h0a.07.07,0,0,1,0,.08l-.51.06h0m1.7-.22a.06.06,0,0,1-.06-.06.07.07,0,0,1,.06-.07l.51-.06s.06,0,.07.05h0a.08.08,0,0,1-.06.08h0l-.51.06h0m23.79-.09s-.05,0-.06-.06l-.09-.5a.08.08,0,0,1,.05-.08.07.07,0,0,1,.08,0h0l.09.51a.08.08,0,0,1,0,.08h0m-22.08-.13a.06.06,0,0,1-.07-.06.09.09,0,0,1,.06-.07h0l.51-.06a.05.05,0,0,1,.07,0h0a.07.07,0,0,1-.05.08l-.51.06h0m1.7-.22s-.06,0-.06-.06,0-.06.06-.06l.51-.07s.06,0,.07,0h0a.07.07,0,0,1-.06.07h0l-.51.06h0m1.71-.22a.06.06,0,0,1-.07-.06.06.06,0,0,1,.06-.06l.51-.07a.08.08,0,0,1,.08,0h0a.07.07,0,0,1-.06.07l-.51.06h0m1.71-.21a.07.07,0,0,1-.07-.07.06.06,0,0,1,.06-.06l.51-.07a.07.07,0,0,1,.07.06h0a.06.06,0,0,1,0,.07l-.52.07h0m1.7-.22a.07.07,0,0,1-.06-.07.06.06,0,0,1,0-.06l.51-.07a.08.08,0,0,1,.08,0h0s0,.07-.06.07l-.51.07h0m1.71-.22a.07.07,0,0,1-.07-.06s0-.07.06-.07l.51-.07s.07,0,.07.06h0a.05.05,0,0,1-.05.07l-.51.07h0m1.7-.22a.07.07,0,0,1-.07-.06.07.07,0,0,1,.06-.07h0l.52-.06s.06,0,.07.05h0s0,.07-.06.07l-.51.07h0m1.71-.22a.07.07,0,0,1-.07-.06.07.07,0,0,1,.06-.07l.51-.06a.05.05,0,0,1,.07.05h0a.07.07,0,0,1-.05.08l-.51.06h0m9.82,0a.06.06,0,0,1-.06,0l-.12-.5a.07.07,0,1,1,.13,0h0c0,.17.07.34.11.51s0,.06-.05.07h0m-8.12-.18a.06.06,0,0,1-.06-.06.07.07,0,0,1,.06-.07l.51-.06s.06,0,.07,0h0a.08.08,0,0,1-.06.08l-.51.06h0m1.71-.22a.06.06,0,0,1-.07-.06.09.09,0,0,1,.06-.07l.51-.06a.05.05,0,0,1,.07,0h0a.07.07,0,0,1-.05.08h0l-.51.06h0m1.7-.22a.06.06,0,0,1,0-.12l.51-.07s.06,0,.07,0h0a.07.07,0,0,1-.06.07l-.51.06h0m1.71-.22a.06.06,0,0,1-.07-.06.06.06,0,0,1,.06-.06l.51-.07s.07,0,.07,0h0a.09.09,0,0,1-.06.07l-.51.06h0m1.71-.21a.07.07,0,0,1-.07-.06.06.06,0,0,1,.06-.07l.51-.07a.08.08,0,0,1,.07,0h0a.06.06,0,0,1-.05.07h0l-.52.07h0",
    transform: "translate(82.37 81.8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    className: "cls-59",
    x: 115.34,
    y: 81.05,
    width: 5.17,
    height: 2.4,
    transform: "matrix(0.99, -0.11, 0.11, 0.99, 73.94, 95.44)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    className: "cls-61",
    x: 116.46,
    y: 78.37,
    width: 2.26,
    height: 3.77,
    transform: "translate(74.19 95.34) rotate(-6.37)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    className: "cls-63",
    x: 129.55,
    y: 79.23,
    width: 5.17,
    height: 2.4,
    transform: "translate(74.23 97.02) rotate(-6.4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    className: "cls-65",
    x: 130.61,
    y: 76.24,
    width: 2.33,
    height: 4.07,
    transform: "translate(74.5 96.9) rotate(-6.37)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    className: "cls-67",
    x: 115.31,
    y: 71.84,
    width: 17.98,
    height: 8.53,
    transform: "translate(74.69 96.06) rotate(-6.37)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    className: "cls-69",
    x: 116.51,
    y: 74.31,
    width: 3.77,
    height: 5.03,
    transform: "translate(122.75 276.24) rotate(-89.43)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    className: "cls-71",
    x: 105.57,
    y: 76.57,
    width: 40.92,
    height: 23.57,
    transform: "translate(68.39 106.22) rotate(-10.49)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    className: "cls-19",
    d: "M125,95.59h0l-.51,0s-.07,0-.06-.07,0-.06.07-.06l.51,0h0l.52-.07a.07.07,0,0,1,.07.06h0s0,.07-.06.07h0l-.51.07h0m-1.71-.12h0l-.51,0a.07.07,0,0,1-.06-.07s0-.06.07-.06l.51,0s.07,0,.06.07a.06.06,0,0,1-.06.06m3.45-.1s-.07,0-.07-.06,0-.07.06-.07l.51-.06a.05.05,0,0,1,.07,0h0a.05.05,0,0,1,0,.07h0l-.51.07h0m-5.17,0h0l-.52,0a.07.07,0,0,1-.06-.07.09.09,0,0,1,.07-.06l.52,0a.06.06,0,0,1,.06.06.06.06,0,0,1-.07.06m-1.71-.11h0l-.51,0s-.06,0-.06-.07h0a.07.07,0,0,1,.07-.06l.51,0s.07,0,.06.06a.07.07,0,0,1-.06.07h0m8.58-.09a.06.06,0,0,1-.06-.06.06.06,0,0,1,.06-.07l.51-.06s.06,0,.07.05h0a.08.08,0,0,1-.06.08h0l-.51.06h0m-10.3,0h0l-.52,0a.07.07,0,0,1-.06-.07h0a.09.09,0,0,1,.07-.06l.52,0a.06.06,0,0,1,.06.06.07.07,0,0,1-.07.07M116.37,95h0l-.51,0s-.06,0-.06-.07a.07.07,0,0,1,.07-.06h0l.51,0a.06.06,0,0,1,.06.07.06.06,0,0,1-.06.06h0m13.71-.1a.07.07,0,0,1,0-.13l.49-.16a.06.06,0,0,1,.08,0,.05.05,0,0,1,0,.08l-.49.16h0m-15.43,0h0l-.52,0a.06.06,0,0,1-.06-.06s0-.07.07-.06h0l.52,0a.07.07,0,0,1,0,.13m-1.71-.12h0l-.51,0a.07.07,0,0,1-.06-.07s0-.06.07-.06l.51,0s.06,0,.06.07a.06.06,0,0,1-.06.06h0m-1.72-.12h0l-.52,0a.09.09,0,0,1-.06-.07.07.07,0,0,1,.07-.06l.52,0a.09.09,0,0,1,.06.07s0,.06-.07.06m-1.71-.12h0l-.43,0,0-.18a.06.06,0,0,1,0-.07.06.06,0,0,1,.08.05h0v.08l.33,0a.06.06,0,0,1,.06.06s0,.07-.06.06h0m22.21-.15a.08.08,0,0,1-.07-.07.06.06,0,0,1,0-.06l.49-.16a.06.06,0,1,1,0,.12l-.49.16h0m1.63-.53a.06.06,0,0,1-.06-.06.07.07,0,0,1,0-.06l.49-.16s.07,0,.08,0a.05.05,0,0,1,0,.08h0l-.49.16h0M135,93.3a.07.07,0,0,1-.07-.06.08.08,0,0,1,.05-.07l.49-.16a.07.07,0,0,1,.08,0,.07.07,0,0,1,0,.08l-.49.16h0m-26.09-.13a.06.06,0,0,1-.06,0c0-.16-.06-.33-.08-.51a.05.05,0,0,1,0-.07s.07,0,.07,0,.06.35.08.51a.05.05,0,0,1,0,.07h0m27.72-.4a.07.07,0,0,1,0-.13l.49-.16a.06.06,0,0,1,.08,0s0,.07,0,.08h0l-.49.16h0m1.64-.54a.07.07,0,0,1-.07-.06.06.06,0,0,1,.05-.06l.49-.16a.06.06,0,1,1,0,.12l-.49.16h0m1.63-.53a.06.06,0,0,1-.06-.06.07.07,0,0,1,0-.06l.49-.16s.07,0,.08,0a.05.05,0,0,1,0,.08l-.49.16h0m-31.25-.23a.06.06,0,0,1-.06,0c0-.17,0-.34-.07-.52s0-.06,0-.07a.08.08,0,0,1,.08.06c0,.17,0,.34.07.51a.07.07,0,0,1-.06.07h0m32.89-.3a.07.07,0,0,1-.07-.06.08.08,0,0,1,0-.07l.49-.15a.05.05,0,0,1,.08,0,.07.07,0,0,1,0,.08l-.49.16h0m1.63-.53a.07.07,0,0,1-.06-.07.08.08,0,0,1,0-.06l.49-.16a.06.06,0,0,1,.08,0,.07.07,0,0,1,0,.09l-.49.16h0m-34.73-.88s-.07,0-.07-.05,0-.35,0-.52,0-.06,0-.07.07,0,.07.06l.06.51s0,.07-.06.07h0m35.42-.26a.08.08,0,0,1-.07,0c0-.17-.05-.34-.07-.51a.06.06,0,0,1,0-.08.06.06,0,0,1,.07,0h0c0,.17.06.34.08.51a.05.05,0,0,1,0,.07h0m-35.59-1.45a.06.06,0,0,1-.06-.06c0-.17,0-.34,0-.52a.06.06,0,0,1,.06-.06.05.05,0,0,1,.07,0h0c0,.17,0,.34,0,.51a.07.07,0,0,1-.06.07h0m35.3-.24a.06.06,0,0,1-.06-.06c0-.16-.07-.33-.1-.5a.05.05,0,0,1,0-.07.06.06,0,0,1,.07,0c0,.17.07.34.11.51a.08.08,0,0,1-.06.08h0m-35.38-1.48a.07.07,0,0,1-.07-.06v-.52a.07.07,0,0,1,.07-.07.07.07,0,0,1,.06.07h0v.51s0,.07-.06.07Zm35-.2a.09.09,0,0,1-.07,0l-.12-.5a.06.06,0,0,1,.05-.08.07.07,0,0,1,.08,0l.12.51s0,.06,0,.07h0M108.69,85a.07.07,0,0,1-.07-.07.06.06,0,0,1,.06-.06l.51-.07s.06,0,.07,0h0a.05.05,0,0,1-.05.07h0l-.52.08h0m1.7-.24a.07.07,0,0,1,0-.13h0l.51-.07a.05.05,0,0,1,.07.05.06.06,0,0,1,0,.08h0l-.51.07h0m1.7-.24a.06.06,0,0,1-.06-.06.08.08,0,0,1,0-.07l.52-.07a.07.07,0,0,1,.07.06h0a.07.07,0,0,1-.06.07l-.51.07h0m30.67-.07a.07.07,0,0,1-.06,0c0-.17-.09-.34-.14-.5a.07.07,0,0,1,0-.08.06.06,0,0,1,.08,0l.15.49a.06.06,0,0,1-.05.08h0m-29-.16a.07.07,0,0,1-.07-.06.07.07,0,0,1,.06-.07l.51-.07s.07,0,.07.06a.06.06,0,0,1-.05.07h0l-.51.07h0m1.7-.23a.06.06,0,0,1-.06-.06.07.07,0,0,1,0-.07l.52-.07a.07.07,0,0,1,.07.06A.07.07,0,0,1,116,84l-.51.07h0m1.71-.23a.06.06,0,0,1-.07-.06.07.07,0,0,1,.06-.07h0l.51-.06a.05.05,0,0,1,.07,0h0a.05.05,0,0,1,0,.07l-.51.07h0m1.7-.22a.07.07,0,0,1-.06-.07.06.06,0,0,1,.05-.06l.52-.07a.07.07,0,0,1,.07.06.07.07,0,0,1-.06.07h0l-.51.07h0m1.71-.22a.07.07,0,0,1-.07-.07.06.06,0,0,1,.06-.06l.51-.07a.07.07,0,0,1,.07.07.06.06,0,0,1-.06.06h0l-.5.06h0m1.7-.21a.06.06,0,0,1-.06-.06.06.06,0,0,1,.06-.07h0l.51-.07a.07.07,0,0,1,.07.06h0s0,.07-.06.07l-.51.07h0M124,83a.06.06,0,0,1-.07-.06.09.09,0,0,1,.06-.07h0l.51-.06a.08.08,0,0,1,.08,0h0a.07.07,0,0,1-.06.07L124,83h0m18.24-.16a.07.07,0,0,1-.06,0c-.06-.17-.11-.34-.16-.49a.06.06,0,1,1,.12,0c.05.15.11.32.16.49a.07.07,0,0,1,0,.08h0m-16.53,0a.06.06,0,0,1-.07-.06.06.06,0,0,1,.06-.06l.51-.07s.07,0,.07.06h0a.06.06,0,0,1,0,.07l-.51.06h0m1.7-.2a.06.06,0,0,1-.06-.06.06.06,0,0,1,.06-.07l.51-.06a.06.06,0,0,1,.07.06s0,.06-.06.07l-.51.06h0m1.71-.2a.07.07,0,0,1-.06-.07.06.06,0,0,1,.06-.06l.51-.06a.08.08,0,0,1,.07,0h0a.07.07,0,0,1-.06.07l-.51.06h0m1.71-.2a.07.07,0,0,1-.07-.06.09.09,0,0,1,.06-.07l.52,0s.06,0,.07,0h0a.08.08,0,0,1-.06.08l-.51.05h0m1.71-.18a.09.09,0,0,1-.07-.06.07.07,0,0,1,.06-.07l.52-.06a.07.07,0,0,1,.07.06s0,.07-.06.07l-.51.06h0m1.71-.18a.09.09,0,0,1-.07-.06.07.07,0,0,1,.07-.07l.51,0a.06.06,0,0,1,.07.06.07.07,0,0,1-.06.07h0l-.51.05h0m1.71-.17a.06.06,0,0,1-.06-.06.06.06,0,0,1,.06-.07l.51,0a.05.05,0,0,1,.07,0s0,.07-.06.07h0l-.51.05h0m1.72-.15s-.07,0-.07-.06a.07.07,0,0,1,.06-.07l.52,0a.09.09,0,0,1,.07.06.07.07,0,0,1-.06.07h0l-.52,0h0m1.71-.12a.07.07,0,0,1-.06-.07s0-.06.06-.06h0l.51,0a.05.05,0,0,1,.07,0h0a.06.06,0,0,1-.06.06h0l-.51,0h0m1.72-.09a.07.07,0,0,1-.07-.06.07.07,0,0,1,.07-.07h.52a.07.07,0,0,1,.06.07.06.06,0,0,1-.06.06h-.52Z",
    transform: "translate(82.37 81.8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    className: "cls-73",
    x: 121.86,
    y: 90.06,
    width: 10.17,
    height: 10.53,
    transform: "translate(69.75 252.77) rotate(-65.36)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    className: "cls-75",
    x: 123.56,
    y: 91.67,
    width: 6.88,
    height: 7.3,
    transform: "translate(88.73 280.36) rotate(-77.45)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    className: "cls-77",
    x: 116.22,
    y: 61.07,
    width: 22.58,
    height: 20.76,
    transform: "translate(87.68 233.44) rotate(-62.54)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    className: "cls-79",
    x: 110.91,
    y: 36.86,
    width: 32.44,
    height: 28.48,
    transform: "translate(109.19 226.23) rotate(-64.84)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    className: "cls-81",
    x: 111.89,
    y: 44.18,
    width: 20.33,
    height: 19.61,
    transform: "translate(83.15 191.49) rotate(-48.53)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    className: "cls-83",
    x: 103.85,
    y: 228.03,
    width: 10.23,
    height: 7.96
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    className: "cls-85",
    x: 22.47,
    y: 150.83,
    width: 8.65,
    height: 7.23,
    transform: "translate(-7.29 131.32) rotate(-38.14)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    className: "cls-87",
    x: 21,
    y: 143.5,
    width: 5.58,
    height: 4.41,
    transform: "translate(-41.3 234.54) rotate(-83.46)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    className: "cls-89",
    x: 38.12,
    y: 148.87,
    width: 12.24,
    height: 9.98,
    transform: "translate(-3.21 141.96) rotate(-38.14)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    className: "cls-91",
    x: 119.31,
    y: 228.71,
    width: 14.4,
    height: 7.05
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    className: "cls-93",
    x: 36.41,
    y: 142.7,
    width: 6.35,
    height: 4.32,
    transform: "translate(-24.74 258.79) rotate(-87.07)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    className: "cls-95",
    x: -4.59,
    y: 94.78,
    width: 68.48,
    height: 33.86,
    transform: "translate(-2.67 207.75) rotate(-82.22)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    className: "cls-97",
    x: -0.76,
    y: 33.46,
    width: 61.96,
    height: 54,
    transform: "translate(45.08 138.81) rotate(-60.53)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    className: "cls-99",
    x: 26.88,
    y: 23,
    width: 17.74,
    height: 17.57,
    transform: "translate(70.59 118.98) rotate(-48.12)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    className: "cls-101",
    x: 29.07,
    y: 17.44,
    width: 18.46,
    height: 18.25,
    transform: "matrix(0.58, -0.82, 0.82, 0.58, 76.83, 124.2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    className: "cls-103",
    x: 24.63,
    y: 10.35,
    width: 23.65,
    height: 23.5,
    transform: "translate(76.75 110.75) rotate(-40.49)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    className: "cls-105",
    x: 30.69,
    y: 24.3,
    width: 5.52,
    height: 5.48,
    transform: "translate(74.41 120.45) rotate(-54.61)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    className: "cls-107",
    x: 37.66,
    y: 39.89,
    width: 14.49,
    height: 14.41,
    transform: "translate(62.21 127.99) rotate(-45.58)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    className: "cls-109",
    x: 42.49,
    y: 36.6,
    width: 26.58,
    height: 24.58,
    transform: "translate(66.43 111.76) rotate(-26.45)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    className: "cls-111",
    x: 66.06,
    y: 36.85,
    width: 6.44,
    height: 6.57,
    transform: "translate(74.74 144.22) rotate(-46.24)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    className: "cls-113",
    x: 64.11,
    y: 36.61,
    width: 13.21,
    height: 9.38,
    transform: "translate(71.37 117.6) rotate(-26.44)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    className: "cls-115",
    x: 37.41,
    y: 36.95,
    width: 30.06,
    height: 40.93,
    transform: "translate(62.24 167.14) rotate(-68.65)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    className: "cls-117",
    x: 23.48,
    y: 45.52,
    width: 12.16,
    height: 11.68,
    transform: "translate(52.7 131.55) rotate(-58.52)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    className: "cls-119",
    x: 25.81,
    y: 33.67,
    width: 17.03,
    height: 17.69,
    transform: "translate(62.51 131.39) rotate(-58.52)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnershipImg);
export default __webpack_public_path__ + "static/media/partnership-img.50f1c03a88806f563f940bff8a2410c8.svg";
export { ForwardRef as ReactComponent };